module.exports = __webpack_public_path__ + "static/tri-2-59140ec13bd7931d97a43057f28af5be.jpg";